import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo/logo.png';
import _imports_1 from '@/assets/images/icons/SocialLinks/telegram.svg';
import _imports_2 from '@/assets/images/icons/SocialLinks/github.svg';
import _imports_3 from '@/assets/images/icons/SocialLinks/slack.svg';
import _imports_4 from '@/assets/images/icons/SocialLinks/Twitter.svg';
import _imports_5 from '@/assets/images/icons/SocialLinks/medium.png';
const _withScopeId = n => (_pushScopeId("data-v-db4f75c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "has-shapes has-bg-brash bg-brash-top mt-lg-5 mt-0",
  style: {
    "padding-top": "55px"
  }
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "row pt-60 pb-60"
};
const _hoisted_4 = {
  class: "col-lg-3 col-md-6"
};
const _hoisted_5 = {
  class: "pr-0 pr-lg-4"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "mb-25",
  href: "#"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mb-4 logo-prompt",
  style: {
    "filter": "grayscale(100%)",
    "width": "90px"
  },
  src: _imports_0
})], -1));
const _hoisted_7 = {
  class: "mb-4 d-flex"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "24px",
    "margin-right": "15px",
    "cursor": "pointer"
  },
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "black",
    "text-decoration": "none",
    "display": "block",
    "width": "100%"
  },
  target: "_blank",
  href: "https://t.me/stfil_cn"
}, "中文", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "black",
    "text-decoration": "none",
    "display": "block",
    "width": "100%"
  },
  target: "_blank",
  href: "https://t.me/stfil_io"
}, "English", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://github.com/stfil-io"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "24px",
    "margin-right": "15px",
    "cursor": "pointer"
  },
  alt: ""
})], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "width": "24px",
    "margin-right": "15px",
    "cursor": "pointer"
  },
  alt: ""
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "black",
    "text-decoration": "none",
    "display": "block",
    "width": "100%"
  },
  target: "_blank",
  href: "https://filecoinproject.slack.com/archives/C0512AMBV98"
}, "中文", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "black",
    "text-decoration": "none",
    "display": "block",
    "width": "100%"
  },
  target: "_blank",
  href: "https://filecoinproject.slack.com/archives/C05CC69E57E"
}, "English", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://twitter.com/stfil_io"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {
    "width": "20px",
    "margin-right": "15px",
    "cursor": "pointer"
  },
  alt: ""
})], -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://medium.com/@STFIL_Protocol"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {
    "width": "20px",
    "margin-right": "15px",
    "cursor": "pointer"
  },
  alt: ""
})], -1));
const _hoisted_17 = {
  class: "mb-2 pt-2"
};
const _hoisted_18 = {
  style: {
    "color": "#000000",
    "border-bottom": "solid 1px #848484",
    "padding-bottom": "7px",
    "margin-bottom": "5px"
  },
  class: "fw-bold fsi-16"
};
const _hoisted_19 = {
  class: "mb-4 pt-2"
};
const _hoisted_20 = {
  style: {
    "color": "#000000",
    "border-bottom": "solid 1px #848484",
    "padding-bottom": "7px",
    "margin-bottom": "5px"
  },
  class: "fw-bold fsi-16"
};
const _hoisted_21 = {
  class: "col-lg-2 col-md col-sm-6"
};
const _hoisted_22 = {
  class: "pl-0 pl-md-3 mt-5 mt-md-0"
};
const _hoisted_23 = {
  class: "font-weight-600 mb-20 text-primary-color"
};
const _hoisted_24 = {
  class: "list-unstyled footer-links text-primary-color"
};
const _hoisted_25 = ["href"];
const _hoisted_26 = ["href"];
const _hoisted_27 = ["href"];
const _hoisted_28 = {
  class: "col-lg-3 col-md col-sm-6"
};
const _hoisted_29 = {
  class: "pl-0 pl-md-3 mt-5 mt-md-0"
};
const _hoisted_30 = {
  class: "font-weight-600 mb-20 text-primary-color"
};
const _hoisted_31 = {
  class: "list-unstyled footer-links text-primary-color"
};
const _hoisted_32 = {
  target: "_blank",
  href: "https://portal.stfil.io/terms/"
};
const _hoisted_33 = {
  target: "_blank",
  href: "https://portal.stfil.io/privacy/"
};
const _hoisted_34 = {
  class: "col-lg-4 col-md col-sm-6 mt-lg-0 mt-5"
};
const _hoisted_35 = {
  class: "fw-bold mb-2"
};
const _hoisted_36 = {
  class: "fw-medium fsi-14 mb-3"
};
const _hoisted_37 = {
  key: 0,
  style: {
    "border-radius": "50px",
    "background-color": "#ffffff",
    "height": "50px",
    "color": "#797979",
    "width": "320px"
  },
  class: "d-flex justify-content-center align-items-center fs-12"
};
const _hoisted_38 = {
  class: "ml-2"
};
const _hoisted_39 = {
  style: {
    "width": "100%",
    "height": "100%"
  },
  class: "subEmailBtn"
};
const _hoisted_40 = {
  class: "footer-bottom"
};
const _hoisted_41 = {
  class: "container"
};
const _hoisted_42 = {
  class: "row"
};
const _hoisted_43 = {
  class: "col-12"
};
const _hoisted_44 = {
  class: "block border-top text-center content"
};
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"shape-1 shape-xs bg-orange rounded-circle\" data-v-db4f75c2></div><div class=\"shape-2 shape-sm-2 bg-cyan rounded-circle\" data-v-db4f75c2></div><div class=\"shape-3 shape-sm bg-yellow rounded-circle\" data-v-db4f75c2></div><div class=\"shape-4 shape-xs-2 bg-cyan rounded-circle\" data-v-db4f75c2></div><div class=\"shape-5 shape-sm-2 bg-yellow rounded-circle\" data-v-db4f75c2></div><div class=\"shape-6 shape-sm-2 bg-orange rounded-circle\" data-v-db4f75c2></div>", 6);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_dropdown, {
    placement: "top"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _hoisted_11, _createVNode(_component_el_dropdown, {
    placement: "top"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }), _hoisted_15, _hoisted_16]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_dropdown, null, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.languageOptions, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          onClick: $event => $options.changeLanguage(item),
          key: index
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_18, [_createTextVNode(_toDisplayString($options.getLanguagetLabel($data.languageValue)) + " ", 1), _createVNode(_component_el_icon, {
      class: "el-icon--right"
    }, {
      default: _withCtx(() => [_createVNode(_component_arrow_down, {
        style: {
          "transform": "translateY(2px)"
        }
      })]),
      _: 1
    })])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_dropdown, null, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.netModeValueOption, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          onClick: $event => $options.netModeChange(item.value),
          key: index
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_20, [_createTextVNode(_toDisplayString($data.netModelValue) + " ", 1), _createVNode(_component_el_icon, {
      class: "el-icon--right"
    }, {
      default: _withCtx(() => [_createVNode(_component_arrow_down, {
        style: {
          "transform": "translateY(2px)"
        }
      })]),
      _: 1
    })])]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("h5", _hoisted_23, _toDisplayString(_ctx.$t('footer.Learn')), 1), _createElementVNode("ul", _hoisted_24, [_createElementVNode("li", null, [_createElementVNode("a", {
    target: "_blank",
    href: _ctx.docsUrlPrefix
  }, _toDisplayString(_ctx.$t('footer.document')), 9, _hoisted_25)]), _createElementVNode("li", null, [_createElementVNode("a", {
    target: "_blank",
    href: `${_ctx.docsUrlPrefix}protocol/security-and-audits`
  }, _toDisplayString(_ctx.$t('footer.audit')), 9, _hoisted_26)]), _createElementVNode("li", null, [_createElementVNode("a", {
    target: "_blank",
    href: `${_ctx.docsUrlPrefix}developers/bug-bounty-program`
  }, _toDisplayString(_ctx.$t('footer.BountyProgram')), 9, _hoisted_27)])])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.$t('footer.Quick Links')), 1), _createElementVNode("ul", _hoisted_31, [_createElementVNode("li", null, [_createElementVNode("a", _hoisted_32, _toDisplayString(_ctx.$t('footer.TermsConditions')), 1)]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_33, _toDisplayString(_ctx.$t('footer.PrivacyPolicy')), 1)])])])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.$t('footer.Stay up to date with')), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('footer.Subscribe to the newsletter for Oasis updates')), 1), $data.subOk ? (_openBlock(), _createElementBlock("span", _hoisted_37, [_createVNode(_component_el_icon, {
    size: "26"
  }, {
    default: _withCtx(() => [_createVNode(_component_SuccessFilled, {
      color: "#00CE92"
    })]),
    _: 1
  }), _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('footer.Subscribe OK')), 1)])) : _createCommentVNode("", true), !$data.subOk ? (_openBlock(), _createElementBlock("form", {
    key: 1,
    onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.handleSubmit && $options.handleSubmit(...args), ["prevent"])),
    id: "emailForm",
    name: "emailForm",
    "data-netlify": "true"
  }, [_createVNode(_component_el_input, {
    size: "large",
    modelValue: $data.emailAddress,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.emailAddress = $event),
    type: "email",
    name: "email",
    placeholder: _ctx.$t('footer.Subscribe Placeholder')
  }, {
    append: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('footer.Subscribe Btn')), 1)]),
      _: 1
    })), [[_directive_loading, $data.subLoading]])]),
    _: 1
  }, 8, ["modelValue", "placeholder"])], 32)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, "©2023 STFIL All rights reserved. " + _toDisplayString(_ctx.referralCode), 1)])])])]), _hoisted_45]);
}